import { Component } from '@angular/core';
import { ResultTypeLabyrinth } from '@workflow/components/questionnaire/questionnaire-item/special-question/labyrinth-test/labyrinth-test.component';
import { WorkflowItemKeyDirective } from '@workflow/directives/workflow-item-key/workflow-item-key.directive';

@Component({
	selector: 'workflow-labyrinth-test-epilog',
	templateUrl: './labyrinth-test-epilog.component.html',
	styleUrls: ['./labyrinth-test-epilog.component.scss']
})
export class LabyrinthTestEpilogComponent {
	constructor(public workflowItemKey: WorkflowItemKeyDirective<ResultTypeLabyrinth>) {}
}
